<!--
    功能：登录成功获取token
-->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive && show"/>
  </div>
</template>

<script>
import { token } from '@/utils';
import baseUrl from "./utils/api";
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      show: false
    };
  },
  created() {
    const reg = (name) =>  new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const result = window.location.hash.substr(1).match(reg('access_token'));
    const state = window.location.hash.substr(1).match(reg('state'));
    const access_token = result ? decodeURIComponent(result[2]) : null;
    const stateType = state ? decodeURIComponent(state[2]) : 3;

    if (access_token) {
      localStorage.setItem('token', access_token);
      this.load();
    } else if (!token.get()) {
      window.location.href = `https://admin.qinglukeji.cn/`;
    } else {
      this.load();
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    load() {
      this.$http.get(`${baseUrl}/api/users`)
        .then(res => {
          this.$store.commit('initMainUser', res)
          this.show = true;
          if (this.$route.path === '/') {
            this.$router.push('/role')
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
    }
  },
};
</script>
<style>
  .el-tree-node.is-current.is-focusable>.el-tree-node__content{
    background-color: #f5f7fa;
  }
</style>
<style lang="scss">
.el-dialog, .el-message-box{
    display: flex;
    flex-direction: column;
    margin:0 !important;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    max-height:calc(100% - 30px);
    max-width:calc(100% - 30px);
  }

  .el-dialog .el-dialog__body{
    flex:1;
    overflow: auto;
  }
  </style>



// WEBPACK FOOTER //
// src/App.vue